<a [routerLink]="defaultUrl" class="owner-list-card">
	<div class="row g-2 align-items-center">
		<div class="col-auto">
			<div class="owner-list-card__avatar">
				<img [src]="owner.pictureUrl" [alt]="owner.name" *ngIf="owner.pictureUrl" />
				<i class="fal fa-image" *ngIf="!owner.pictureUrl"></i>
			</div>
		</div>
		<div class="col">
			<p class="owner-list-card__name">{{ owner.name }}</p>
			<ul class="owner-list-card__type" *ngIf="owner?.client">
				<li><i class="far fa-th-list"></i>{{ owner.client?.name }}</li>
				<li *ngIf="owner?.group"><i class="far fa-layer-group"></i>{{ owner.group?.name }}</li>
			</ul>
		</div>
	</div>
</a>
